import CalendarAPI from "./CalendarAPI";
import { ELYXCentralStore, CalendarStore } from "../ELYXStore";
import ELYXConstants from "../ELYXConstants";
import store from "../../store/index";
const AuthStore = store.state.auth; // !!! AuthStore.user IS NOT AVAILABLE HERE, THAT IS WHY WE GET AUTHSTORE ONLY

const CalendarMethods = {
  async getUserBookingData() {
    try {
      const response = await CalendarAPI.getUserBookingData(AuthStore.user._id);
      if (!response || !response.success) {
        throw new Error("@CalendarMethods.getUserBookingData: Request failed.");
      }

      const userBookingData = response.data;
      if (!userBookingData) {
        throw new Error("@CalendarMethods.getUserBookingData: Failed to get user booking data.");
      }
      CalendarStore.methods.updateBookingRestrictionData(userBookingData);
      if (userBookingData.bookingFrozen) {
        ELYXCentralStore.methods.setModal(ELYXConstants.modals.CalendarBookingFrozenModal);
      }
    } catch (error) {
      console.error("@CalendarMethods.getUserBookingData: ", error);
    }
  },

  async getNrOfUsedFreeSessions() {
    if (AuthStore.user && !AuthStore.user.isUserPremium) {
      const response = await CalendarAPI.getNrOfUsedFreeSessions(AuthStore.user._id);
      if (response && response.success) {
        CalendarStore.methods.setNrOfUsedFreeSessions(response.data);
      }
    }
  },
};

export default CalendarMethods;
